var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.466,
    height: 53.466,
    viewBox: "0 0 53.466 53.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_963",
    "data-name": "Ellipse 963",
    cx: 26.733,
    cy: 26.733,
    r: 26.733,
    transform: "translate(0 0)",
    fill: "#32ba7c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_108731",
    "data-name": "Path 108731",
    d: "M188.8,174.769l13.746,13.746a26.715,26.715,0,0,0,19.818-25.805v-.759L211.569,152Z",
    transform: "translate(-168.898 -135.977)",
    fill: "#0aa06e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29021",
    "data-name": "Group 29021",
    transform: "translate(8.981 13.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108732",
    "data-name": "Path 108732",
    d: "M103.626,211.28a3.157,3.157,0,0,1,0,4.385l-2.446,2.446a3.157,3.157,0,0,1-4.385,0l-10.71-10.794a3.157,3.157,0,0,1,0-4.385l2.446-2.446a3.157,3.157,0,0,1,4.385,0Z",
    transform: "translate(-85.2 -191.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108733",
    "data-name": "Path 108733",
    d: "M183.838,126.085a3.157,3.157,0,0,1,4.385,0l2.446,2.446a3.157,3.157,0,0,1,0,4.385l-18.553,18.468a3.157,3.157,0,0,1-4.385,0l-2.446-2.446a3.157,3.157,0,0,1,0-4.385Z",
    transform: "translate(-156.051 -125.2)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic-success.e01f3273a1100e039b1673c90f2673ae.svg";
export { ForwardRef as ReactComponent };